export default __webpack_public_path__ + "static/media/red3.eeca479c.jpg";